/**
 * Central date helpers for the duty roster.
 * Replaces duplicated by_date and updateDate functions across views.
 */

/**
 * Sort function for missions/positions by start_date.
 * @param {{ start_date: string }} a
 * @param {{ start_date: string }} b
 * @returns {number}
 */
export function byDate(a, b) {
  return new Date(a.start_date).valueOf() - new Date(b.start_date).valueOf()
}

/**
 * Handles date picker updates from q-date.
 * Supports both single date (string) and date range ({from, to}).
 *
 * @param {{ start_date: string, end_date: string }} mission - The mission to update
 * @param {string|{from:string,to:string}|null} d - Value from q-date
 */
export function updateMissionDate(mission, d) {
  if (typeof d === 'string') {
    mission.start_date = d
    mission.end_date = d
  } else if (typeof d === 'object' && d !== null) {
    mission.start_date = d.from
    mission.end_date = d.to
  } else {
    mission.start_date = ''
    mission.end_date = ''
  }
}
